import { render } from "./Capk.vue?vue&type=template&id=226975a4&scoped=true"
import script from "./Capk.vue?vue&type=script&lang=js"
export * from "./Capk.vue?vue&type=script&lang=js"

import "./Capk.vue?vue&type=style&index=0&id=226975a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226975a4"]])

export default __exports__